{
  "name": "@proj-airi/stage-ui",
  "type": "module",
  "version": "0.10.2",
  "private": true,
  "description": "Shared core for stage",
  "author": {
    "name": "Moeru AI Project AIRI Team",
    "email": "airi@moeru.ai",
    "url": "https://github.com/moeru-ai"
  },
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/moeru-ai/airi.git",
    "directory": "packages/stage-ui"
  },
  "exports": {
    ".": "./src/components/index.ts",
    "./components/scenarios/chat": "./src/components/scenarios/chat/index.ts",
    "./components/scenarios/settings/model-settings": "./src/components/scenarios/settings/model-settings/index.ts",
    "./components/scenes": "./src/components/scenes/index.ts",
    "./components/*": "./src/components/*.ts",
    "./components": "./src/components/index.ts",
    "./composables/*": "./src/composables/*.ts",
    "./composables": "./src/composables/index.ts",
    "./constants/*": "./src/constants/*.ts",
    "./constants": "./src/constants/index.ts",
    "./libs/inference/adapters/*": "./src/libs/inference/adapters/*.ts",
    "./libs/inference": "./src/libs/inference/index.ts",
    "./libs/*": "./src/libs/*.ts",
    "./libs": "./src/libs/index.ts",
    "./tools/mcp": "./src/tools/mcp.ts",
    "./stores/providers/aliyun": "./src/stores/providers/aliyun/index.ts",
    "./stores/analytics": "./src/stores/analytics/index.ts",
    "./stores/analytics/posthog": "./src/stores/analytics/posthog.ts",
    "./stores/analytics/privacy-policy": "./src/stores/analytics/privacy-policy.ts",
    "./stores/character": "./src/stores/character/index.ts",
    "./stores/character/orchestrator/spark-notify-agent": "./src/stores/character/orchestrator/spark-notify-agent.ts",
    "./stores/settings/analytics": "./src/stores/settings/analytics.ts",
    "./stores/settings": "./src/stores/settings/index.ts",
    "./stores/modules/vision": "./src/stores/modules/vision/index.ts",
    "./stores/mcp-tool-bridge": "./src/stores/mcp-tool-bridge.ts",
    "./stores/*": "./src/stores/*.ts",
    "./stores": "./src/stores/index.ts",
    "./workers/vad": "./src/workers/vad/index.ts",
    "./workers/*": "./src/workers/*.ts",
    "./workers": "./src/workers/index.ts",
    "./utils": "./src/utils/index.ts",
    "./utils/tts": "./src/utils/tts.ts",
    "./types/*": "./src/types/*.ts",
    "./types": "./src/types/index.ts"
  },
  "scripts": {
    "typecheck": "vue-tsc --noEmit",
    "story:dev": "histoire dev",
    "story:build": "histoire build",
    "story:build-base": "histoire build --base /ui",
    "story:preview": "histoire preview",
    "build": "echo \"No build step required\"",
    "test": "vitest",
    "test:run": "vitest run"
  },
  "dependencies": {
    "@date-fns/utc": "^2.1.1",
    "@formkit/auto-animate": "^0.9.0",
    "@huggingface/transformers": "^3.8.1",
    "@moeru/eventa": "catalog:",
    "@moeru/std": "catalog:",
    "@opentelemetry/api": "^1.9.1",
    "@opentelemetry/core": "^2.7.0",
    "@opentelemetry/sdk-trace-base": "^2.7.0",
    "@pinia/colada": "catalog:",
    "@proj-airi/audio": "workspace:^",
    "@proj-airi/ccc": "workspace:^",
    "@proj-airi/chromatic": "^1.1.1",
    "@proj-airi/core-agent": "workspace:^",
    "@proj-airi/core-character": "workspace:^",
    "@proj-airi/drizzle-duckdb-wasm": "catalog:",
    "@proj-airi/font-chillroundm": "workspace:^",
    "@proj-airi/font-cjkfonts-allseto": "workspace:^",
    "@proj-airi/font-xiaolai": "workspace:^",
    "@proj-airi/i18n": "workspace:^",
    "@proj-airi/model-driver-lipsync": "workspace:^",
    "@proj-airi/pipelines-audio": "workspace:^",
    "@proj-airi/server-sdk": "workspace:^",
    "@proj-airi/server-sdk-shared": "workspace:^",
    "@proj-airi/stage-shared": "workspace:^",
    "@proj-airi/stage-ui-live2d": "workspace:^",
    "@proj-airi/stage-ui-spine": "workspace:^",
    "@proj-airi/stage-ui-three": "workspace:^",
    "@proj-airi/ui": "workspace:^",
    "@ricky0123/vad-web": "^0.0.30",
    "@shikijs/rehype": "^4.0.2",
    "@shopify/draggable": "catalog:",
    "@vueuse/core": "catalog:",
    "@vueuse/motion": "^3.0.3",
    "@vueuse/shared": "^14.2.1",
    "@xsai-ext/providers": "catalog:",
    "@xsai-transformers/embed": "^0.1.0",
    "@xsai-transformers/shared": "^0.1.0",
    "@xsai/embed": "catalog:",
    "@xsai/generate-speech": "catalog:",
    "@xsai/generate-text": "catalog:",
    "@xsai/generate-transcription": "catalog:",
    "@xsai/model": "catalog:",
    "@xsai/shared": "catalog:",
    "@xsai/shared-chat": "catalog:",
    "@xsai/stream-text": "catalog:",
    "@xsai/stream-transcription": "catalog:",
    "@xsai/tool": "catalog:",
    "@xsai/utils-chat": "catalog:",
    "animejs": "^4.3.6",
    "async-mutex": "catalog:",
    "better-auth": "catalog:",
    "culori": "^4.0.2",
    "d3": "catalog:",
    "date-fns": "^4.1.0",
    "dompurify": "^3.4.0",
    "embla-carousel-autoplay": "9.0.0-rc01",
    "embla-carousel-vue": "catalog:",
    "es-toolkit": "catalog:",
    "gpuu": "^1.0.7",
    "hono": "catalog:",
    "html2canvas": "^1.4.1",
    "idb-keyval": "catalog:",
    "kokoro-js": "^1.2.1",
    "localforage": "^1.10.0",
    "mediabunny": "^1.40.1",
    "nanoid": "^5.1.9",
    "node-vibrant": "^4.0.4",
    "ofetch": "^1.5.1",
    "pinia": "catalog:",
    "posthog-js": "catalog:",
    "rehype-katex": "^7.0.1",
    "rehype-parse": "^9.0.1",
    "rehype-stringify": "^10.0.1",
    "reka-ui": "^2.9.6",
    "remark-math": "^6.0.0",
    "remark-parse": "^11.0.0",
    "remark-rehype": "^11.1.2",
    "shiki": "^4.0.2",
    "splitpanes": "catalog:",
    "unified": "^11.0.5",
    "unist-builder": "^4.0.0",
    "unist-util-visit": "^5.1.0",
    "unspeech": "catalog:xsai",
    "unstorage": "catalog:",
    "uuid": "^13.0.0",
    "valibot": "catalog:",
    "vaul-vue": "^0.4.1",
    "vue-i18n": "^11.3.2",
    "vue-router": "^5.0.4",
    "vue-sonner": "^2.0.9",
    "web-haptics": "catalog:",
    "xast-util-to-xml": "^4.0.0",
    "xastscript": "^4.0.0",
    "xsschema": "catalog:",
    "zod": "^4.3.6"
  },
  "devDependencies": {
    "@fontsource-variable/comfortaa": "^5.2.8",
    "@fontsource-variable/dm-sans": "^5.2.8",
    "@fontsource-variable/jura": "^5.2.7",
    "@fontsource-variable/nunito": "catalog:",
    "@fontsource-variable/quicksand": "^5.2.10",
    "@fontsource-variable/urbanist": "^5.2.7",
    "@fontsource/dm-mono": "^5.2.7",
    "@fontsource/dm-serif-display": "^5.2.8",
    "@fontsource/gugi": "^5.2.7",
    "@fontsource/kiwi-maru": "^5.2.8",
    "@fontsource/m-plus-rounded-1c": "^5.2.10",
    "@histoire/plugin-vue": "catalog:",
    "@iconify-json/carbon": "^1.2.20",
    "@iconify-json/eos-icons": "^1.2.4",
    "@iconify-json/lucide": "^1.2.102",
    "@iconify-json/mingcute": "^1.2.7",
    "@iconify-json/simple-icons": "^1.2.78",
    "@iconify-json/solar": "^1.2.5",
    "@iconify-json/svg-spinners": "^1.2.4",
    "@iconify-json/vscode-icons": "^1.2.45",
    "@moeru/std": "catalog:",
    "@pinia/testing": "catalog:",
    "@proj-airi/lobe-icons": "^1.0.19",
    "@proj-airi/stream-kit": "workspace:*",
    "@types/audioworklet": "catalog:",
    "@types/culori": "^4.0.1",
    "@types/d3": "catalog:",
    "@types/hast": "catalog:",
    "@types/splitpanes": "catalog:",
    "@types/unist": "catalog:",
    "@types/ws": "^8.18.1",
    "@unocss/reset": "^66.6.8",
    "@vitejs/plugin-vue": "^6.0.6",
    "@webgpu/types": "catalog:",
    "clustr": "^1.0.2",
    "csstype": "^3.2.3",
    "histoire": "catalog:",
    "is-network-error": "catalog:",
    "unocss": "^66.6.8",
    "unplugin-basemove": "0.0.1",
    "unplugin-info": "catalog:",
    "unplugin-yaml": "^4.1.0",
    "vite": "^6.4.2",
    "vitest-browser-vue": "catalog:",
    "vue": "catalog:",
    "vue-tsc": "^3.2.6",
    "ws": "catalog:"
  }
}
